(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningDetailController', WarningDetailController);

    WarningDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', '$http'];

    function WarningDetailController($scope, $rootScope, $stateParams, entity, $http) {
        var vm = this;
        vm.warning = entity;
        vm.isGreengrassObjectType = false;

        if (vm.warning.$promise) {
            vm.warning.$promise.then(function() {
                normalizeWarningResponse(vm.warning);
                resolveGreengrassType(vm.warning);
            });
        } else {
            normalizeWarningResponse(vm.warning);
            resolveGreengrassType(vm.warning);
        }

        var unsubscribe = $rootScope.$on('jotApp:warningUpdate', function(event, result) {
            vm.warning = result;
            normalizeWarningResponse(vm.warning);
            resolveGreengrassType(vm.warning);
        });
        $scope.$on('$destroy', unsubscribe);

        function resolveGreengrassType(warning) {
            if (warning.tabObjectTypes == null || warning.tabObjectTypes.id == null) {
                vm.isGreengrassObjectType = false;
                return;
            }

            if (warning.tabObjectTypes.greengrassType === true ||
                warning.tabObjectTypes.greengrassType === false) {
                vm.isGreengrassObjectType = warning.tabObjectTypes.greengrassType === true;
                return;
            }

            // fallback
            $http.get('api/tab-object-types/' + warning.tabObjectTypes.id)
                .then(function(response) {
                    warning.tabObjectTypes.greengrassType = response.data.greengrassType;
                    vm.isGreengrassObjectType = response.data.greengrassType === true;
                })
                .catch(function() {
                    vm.isGreengrassObjectType = false;
                });
        }

        vm.hasAutoRepairResponse = function() {
            return vm.warning != null && (
                vm.warning.macro != null ||
                vm.warning.action != null ||
                vm.warning.greengrassCommandName != null
            );
        };

        vm.getResponseType = function() {
            if (vm.warning == null) return null;
            if (vm.warning.macro != null) return 'Macro';
            if (vm.warning.action != null || vm.warning.greengrassCommandName != null) return 'Single Command';
            return null;
        };

        vm.getResponseBadgeLabel = function() {
            return vm.isGreengrassObjectType ? 'Greengrass' : 'Kura';
        };

        vm.prettyLabel = function(value) {
            if (!value) return '';
            return value.replace(/_/g, ' ').toLowerCase()
                .replace(/\b\w/g, function(letter) { return letter.toUpperCase(); });
        };

        function normalizeWarningResponse(warning) {
            if (warning == null) return;

            if (warning.greengrassArguments != null && angular.isString(warning.greengrassArguments)) {
                try {
                    warning.greengrassArguments = angular.fromJson(warning.greengrassArguments);
                } catch (e) {
                    warning.greengrassArguments = {};
                }
            }

            if (warning.actionArguments != null && angular.isString(warning.actionArguments)) {
                try {
                    warning.actionArguments = angular.fromJson(warning.actionArguments);
                } catch (e) {
                    warning.actionArguments = {};
                }
            }

            if (warning.greengrassArguments == null &&
                warning.actionArguments != null) {

                var actionArguments = angular.copy(warning.actionArguments);

                if (actionArguments.__greengrassCommand != null) {

                    warning.greengrassCommandName = actionArguments.__greengrassCommand;
                    warning.greengrassTarget      = actionArguments.__greengrassTarget;

                    delete actionArguments.__greengrassCommand;
                    delete actionArguments.__greengrassTarget;

                    warning.greengrassArguments = actionArguments;
                }
            }
        }

        vm.hasKeys = function(obj) {
            return obj && Object.keys(obj).length > 0;
        };
    }
})();
